import { render, staticRenderFns } from "./DeclarationListItem.vue?vue&type=template&id=1cc64fa1&scoped=true&"
import script from "./DeclarationListItem.vue?vue&type=script&lang=ts&"
export * from "./DeclarationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationListItem.vue?vue&type=style&index=0&id=1cc64fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc64fa1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
